export default "__VITE_ASSET__5HcOo8X$__"